import { type FC } from "react"

import { aiGenerationCreditCosts } from "@forento/core/models/ai"
import { toNumberFormat } from "@forento/core/utilities/number"

import AiGenerationDiscountNotice from "~/components/AiGenerationDiscountNotice"
import Link from "~/components/Link"
import { usePlatform } from "~/contexts/UserContext"
import { getBuyAiCreditsUrl } from "~/utilities/forentoAiAnalytics"

const Usage: FC = () => {
	const platform = usePlatform()!

	const cost = aiGenerationCreditCosts.course
	const hasEnoughCredits = cost !== null && platform.aiCreditBalance >= cost

	return (
		<div className="mb-4 rounded-lg border border-gray-200 bg-white p-4">
			<div className="mb-3 flex items-center justify-between">
				<div className="text-sm font-semibold text-gray-900">AI credits</div>
				<Link to={getBuyAiCreditsUrl("course")} className="text-primary text-xs font-medium hover:underline">
					Purchase credits
				</Link>
			</div>
			<div className="grid gap-3 sm:grid-cols-2">
				<div className="rounded-lg bg-gray-50 p-3">
					<div className="text-xs text-gray-500">Available balance</div>
					<div className="text-lg font-semibold text-gray-900">
						{toNumberFormat(platform.aiCreditBalance)} credits
					</div>
				</div>
				<div className="rounded-lg bg-gray-50 p-3">
					<div className="text-xs text-gray-500">This generation costs</div>
					<div className="text-lg font-semibold text-gray-900">{toNumberFormat(cost)} credits</div>
				</div>
			</div>
			<AiGenerationDiscountNotice className="mt-3" />
			{!hasEnoughCredits && (
				<p className="mt-3 text-sm text-red-600">Purchase more credits before generating a full course.</p>
			)}
		</div>
	)
}

export default Usage
